export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation d'un chèque électronique"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte de dépôt"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Série"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'activation"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vérifier"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer le chèque électronique"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Montant"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])},
  "status": {
    "issued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actif"])},
    "activated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])},
    "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulé"])},
    "activating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation"])},
    "returning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour"])},
    "prepare": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En attente"])}
  }
}